import _ from "lodash";
import { getGlobalTimezone } from "./TimezoneHelpers";
import { i18n } from "lib/i18n";

/**
 *
 * This utility memoizes function while considering the key items passed as params
 * It assumes underline function fn takes single param that is an object
 *
 * @param {function} fn - the function that needs to be memoized
 * @param {function} resolver - a resolver that will be used to generate the key
 * @param {Array} items - a list of string items that will define the keys for the memoization
 * @returns - the memoized function
 */

export const getMemoizedItemsFunction = ({
  fn,
  resolver = JSON.stringify,
  items = [],
}) => {
  const fnWrapper = params => {
    let extendedParams = { ...params };

    if (_.includes(items, "LANGUAGE")) {
      const { t } = i18n;
      extendedParams = _.merge(extendedParams, { t });
    }

    if (_.includes(items, "TIMEZONE")) {
      const timezone = getGlobalTimezone();
      extendedParams = _.merge(extendedParams, { timezone });
    }

    // Add other conditions for future keys as needed
    return fn(extendedParams);
  };

  // Resolver wrapper that conditionally adds keys based on the items array
  const resolverWrapper = params => {
    const resolverKeyParts = [resolver(params)]; // Start with the base resolver value

    if (_.includes(items, "TIMEZONE")) {
      const timezone = getGlobalTimezone();
      resolverKeyParts.push(timezone);
    }

    if (_.includes(items, "LANGUAGE")) {
      const { language } = i18n;
      resolverKeyParts.push(language);
    }

    // Add other conditions for future keys as needed
    return resolverKeyParts.join("_"); // Combine all parts into a single cache key
  };

  return _.memoize(fnWrapper, resolverWrapper);
};
